export default {
  name: 'Description',
  edit: {
    form: 'description-input',
    label: 'Edit Description',
    handler: value => value,
  },
};
